import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';
import { AssistMigrationPreview } from 'types/assist/assistMigration';

interface PreviewAssistMigrationResponse {
  success: boolean;
  data: AssistMigrationPreview | null;
}

export const previewAssistMigration = (
  businessId: number,
): AxiosPromise<PreviewAssistMigrationResponse> =>
  httpClient({
    method: 'POST',
    url: `/super-admin/businesses/${businessId}/assist/migration/preview`,
  });
